<div class="container-horizontal-padding container-vertical-padding animated fadeIn">

  <div class="card">

    <div class="card-header">
      {{'COMMON_HISTORY' | translate}}
    </div>

    <div class="card-body">
      <table class="table table-striped table-bordered">
        <thead>
        <tr>
          <th class="table-sorter-header">
            <app-table-field-sorter [orderField]="Type.OrderField.HISTORY_ISSUER_USER_PERSON_NAME"
                                    [orderType]="queryModel.getOrderType(Type.OrderField.HISTORY_ISSUER_USER_PERSON_NAME)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'COMMON_HISTORY_USER' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header" *ngIf="hasType()">
            <app-table-sorter-no-op [text]="'COMMON_HISTORY_TYPE' | translate"></app-table-sorter-no-op>
          </th>
          <th class="table-sorter-header" *ngIf="hasState()">
            <app-table-sorter-no-op [text]="'COMMON_HISTORY_STATE' | translate"></app-table-sorter-no-op>
          </th>
          <th class="table-sorter-header hidden-xs-down w-10">
            <app-table-sorter-no-op
              [text]="'COMMON_HISTORY_APPLICATION_TYPE' | translate"></app-table-sorter-no-op>
          </th>
          <th class="table-sorter-header hidden-lg-down">
            <app-table-field-sorter [orderField]="Type.OrderField.HISTORY_MOBILE_APPLICATION_APPLICATION_ID"
                                    [orderType]="queryModel.getOrderType(Type.OrderField.HISTORY_MOBILE_APPLICATION_APPLICATION_ID)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'COMMON_HISTORY_APPLICATION_ID' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header hidden-sm-down w-15">
            <app-table-field-sorter [orderField]="Type.OrderField.HISTORY_CREATION_TIME"
                                    [orderType]="queryModel.getOrderType(Type.OrderField.HISTORY_CREATION_TIME)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'COMMON_HISTORY_CREATION_TIME' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header w-table-actions-single">
            <app-table-sorter-no-op></app-table-sorter-no-op>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of historyList | paginate: {
                                                      itemsPerPage: queryModel.itemsPerPage,
                                                      currentPage: queryModel.currentPage,
                                                      totalItems: queryModel.currentNumberOfItems }">
          <td class="responsive-table-column">{{item.user.personName}}</td>
          <td class="responsive-table-column" *ngIf="hasType()">{{item.typeString | translate}}</td>
          <td class="responsive-table-column" *ngIf="hasState()">{{item.stateString | translate}}</td>
          <td class="responsive-table-column hidden-xs-down">{{item.applicationClassification | translate}}</td>
          <td class="responsive-table-column hidden-lg-down">{{item.applicationId}}</td>
          <td class="responsive-table-column hidden-sm-down">{{item.creationTime | date:'short'}}</td>
          <td class="responsive-table-column">
            <a class="icons-table-group cursor-pointer"
               *ngIf="item.changeLog !== 'null'"
               (click)="openDetailDialog(item.changeLog)">
              <i class="icomoon icons-table-item icomoon-detail icomoon-detail-table"
                 title="{{'COMMON_BUTTON_DETAILS' | translate}}"></i>
            </a>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th class="table-sorter-header">
            <app-table-field-sorter [orderField]="Type.OrderField.HISTORY_ISSUER_USER_PERSON_NAME"
                                    [orderType]="queryModel.getOrderType(Type.OrderField.HISTORY_ISSUER_USER_PERSON_NAME)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'COMMON_HISTORY_USER' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header" *ngIf="hasType()">
            <app-table-sorter-no-op [text]="'COMMON_HISTORY_TYPE' | translate"></app-table-sorter-no-op>
          </th>
          <th class="table-sorter-header" *ngIf="hasState()">
            <app-table-sorter-no-op [text]="'COMMON_HISTORY_STATE' | translate"></app-table-sorter-no-op>
          </th>
          <th class="table-sorter-header hidden-xs-down w-10">
            <app-table-sorter-no-op
              [text]="'COMMON_HISTORY_APPLICATION_TYPE' | translate"></app-table-sorter-no-op>
          </th>
          <th class="table-sorter-header hidden-lg-down">
            <app-table-field-sorter [orderField]="Type.OrderField.HISTORY_MOBILE_APPLICATION_APPLICATION_ID"
                                    [orderType]="queryModel.getOrderType(Type.OrderField.HISTORY_MOBILE_APPLICATION_APPLICATION_ID)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'COMMON_HISTORY_APPLICATION_ID' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header hidden-sm-down w-15">
            <app-table-field-sorter [orderField]="Type.OrderField.HISTORY_CREATION_TIME"
                                    [orderType]="queryModel.getOrderType(Type.OrderField.HISTORY_CREATION_TIME)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'COMMON_HISTORY_CREATION_TIME' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header w-table-actions-single">
            <app-table-sorter-no-op></app-table-sorter-no-op>
          </th>
        </tr>
        </tfoot>
      </table>
      <app-table-paging
        [currentNumberOfItems]="queryModel.currentNumberOfItems"
        [totalNumberOfItems]="queryModel.totalNumberOfItems"
        [itemsPerPage]="queryModel.itemsPerPage"
        (pageChange)="pageChanged($event)"
        (itemsPerPageChange)="itemsPerPageChanged($event)">
      </app-table-paging>
    </div>
  </div>
</div>
